import {forEach, size} from "lodash";
import {administeredCssColor, ownedCssColor, relatedCssColor} from "./InstanceRoleColor";
import React from "react";

export const addToDispatchPayload = ( payload, role, content ) =>
{
    if( role === "related" ){ payload.userOrganizations_withType_related = content; }
    else if( role === "owned" ){ payload.userOrganizations_withType_owned = content; }
    else if( role === "administered" ){ payload.userOrganizations_withType_administered = content; }
};

export const getBackgroundColor = ( role ) =>
{
    let backgroundColor = '';
    if( role === "related" ){ backgroundColor = relatedCssColor; }
    else if( role === "owned" ){ backgroundColor = ownedCssColor; }
    else if( role === "administered" ){ backgroundColor = administeredCssColor; }
    return backgroundColor;
};

export const getCount = ( state, role ) =>
{
    let array = null;
    if( role === "related" ){ array = state.resource.userOrganizations_withType_related; }
    else if( role === "owned" ){ array =  state.resource.userOrganizations_withType_owned; }
    else if( role === "administered" ){ array = state.resource.userOrganizations_withType_administered; }
    return size( array );
};

export const InstanceRolesIndication = ({ state, instanceUuid, children }) =>
{

    // TODO: make MyInstanceRole object which encapsulated this and some stuff in Filter
    // FIXME: O(N*2)

    // const state2 = state._state;
    if( !state.resource )
    {
        return (<div>{children}</div>);
    }

    let isRelated = false;
    let isAdministered = false;
    let isOwned = false;
    let totalParts = 0;
    forEach( state.resource.userOrganizations_withType_related, ( instance ) =>
    {
        if( instance.id === instanceUuid )
        {
            isRelated = true;
            totalParts++;
        }
    });
    forEach( state.resource.userOrganizations_withType_administered, ( instance ) =>
    {
        if( instance.id === instanceUuid )
        {
            isAdministered = true;
            totalParts++;
        }
    });
    forEach( state.resource.userOrganizations_withType_owned, ( instance ) =>
    {
        if( instance.id === instanceUuid )
        {
            isOwned = true;
            totalParts++;
        }
    });

    let heightPercent = 0;
    let topPercentIncrement = 0;
    let topPercent = 0;
    if( totalParts === 3 )
    {
        heightPercent = '33%';
        topPercentIncrement = 33.333;
    }
    else if( totalParts === 2 )
    {
        heightPercent = '50%';
        topPercentIncrement = 50;
    }
    else if( totalParts === 1 )
    {
        heightPercent = '10%';
        topPercentIncrement = 100;
    }

    let lines = [];
    let addLine = ( color, height, topPercentAsNumber ) =>
    {
        lines.push(
            <div
                style={{position: 'absolute', top: topPercentAsNumber + '%', left: 0, width: '4px', height: height}}
            >
                <div style={{position: 'absolute', top: 0, left: 0, right: 0 , bottom: 0, margin: '2px 0 2px 0', background: color }}></div>
            </div>
        );
    };

    if( isOwned ) { addLine( ownedCssColor, heightPercent, topPercent ); topPercent += topPercentIncrement; }
    if( isAdministered ) { addLine( administeredCssColor, heightPercent, topPercent ); topPercent += topPercentIncrement; }
    if( isRelated ) { addLine( relatedCssColor, heightPercent, topPercent ); topPercent += topPercentIncrement; }

    return (
        <div style={{ position: 'relative'}}>
            <div style={{
                position: 'absolute',
                /* height: '100%', */
                height: '205%',
                top: '-45%',
                left: '-18px'}}>{lines}</div>
            {children}
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/Atollon/Instance/InstanceRoles/index.js